import interact from 'interactjs';
import './_easings';

export function draggable() {
  const grab = document.querySelectorAll('.js-draggable');
  const textContent = document.querySelectorAll('.js-issue-content-element');
  let grabLength = grab.length;

  if(grab){
    for(let i = 0; i < grab.length; i++){
      const _grab = grab[i];

      let restrict = [];
      if(!_grab.classList.contains('is-no-restrict')) {
        restrict = [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true
          })
        ]
      }

      const dragStartListner = (event) => {
        const target = event.target;
        const targetId = target.getAttribute('data-content');
        const targetContent = document.querySelector(`.js-content-${targetId}`);
        target.classList.add('is-dragging');
        target.style.zIndex = grabLength;
        if(targetContent) targetContent.classList.add('is-active');
        grabLength = grabLength+1;
      }

      const dragMoveListner = (event) => {
        const target = event.target
        const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
        target.style.transform = `translate(${x}px,${y}px)`
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      }

      const dragEndListner = (event) => {
        const target = event.target;
        const targetId = target.getAttribute('data-content');
        const targetContent = document.querySelector(`.js-content-${targetId}`);
        setTimeout(function(){
          target.classList.remove('is-dragging');
          if(targetContent) targetContent.classList.remove('is-active');
        }, 50)
      }

      const initInteract = () => {
        interact(_grab).draggable({
          autoScroll: false,
          inertia: false,
          modifiers: restrict,
          listeners: {
            start (event) {
              dragStartListner(event);
            },
            move (event) {
              dragMoveListner(event);
            },
            end (event) {
              dragEndListner(event);
            }
          }
        });
      }
      initInteract();
    }
  }
}